import React from "react";
import GroupsInfoExpandableFaqRow from "./GroupsInfoExpandableFaqRow";

const faqData = [
  {
    answer: (
      <>
        Once we receive your payment, we will collect information from you about
        each licensee in your group. We&apos;ll then create the accounts and
        send an email with login info to each licensee directly—it&apos;s
        seamless and easy!
      </>
    ),
    question: "How does the sign up process for groups work?"
  },
  {
    answer: (
      <>
        Yes! Each licensee receives a unique username and password that gives
        them access to their own private account.
      </>
    ),
    question: "Does everyone get their own account?"
  },
  {
    answer: (
      <>
        There are a bunch!
        <br />
        <ul>
          <li>
            <strong>Big discounts:</strong> Savings of up to 93% off our
            standard subscription rates.
          </li>
          <li>
            <strong>Easier to manage renewals:</strong> Everyone can renew (or
            choose not to renew) in one group.
          </li>
          <li>
            <strong>Faster to set up accounts:</strong> Everyone gets their own
            account info without having to sign up or fill out any paperwork or
            online forms.
          </li>
          <li>
            <strong>Prioritized support:</strong> You&apos;ll have direct access
            to LitCharts customer support, including phone support if necessary.
          </li>
          <li>
            <strong>Onboarding help:</strong> We&apos;ll help you and your
            licensees with any questions that arise about the sign up process or
            how to use LitCharts.
          </li>
        </ul>
      </>
    ),
    question:
      "What are the benefits of purchasing a group subscription vs. just buying individual subscriptions?"
  },
  {
    answer: (
      <>
        Our customer service team will create a custom invoice for you that you
        can use to generate a PO. Once we receive your PO and payment,
        we&apos;ll contact you to set up your accounts, which typically takes
        1-2 business days at most.
      </>
    ),
    question: "How does purchasing with a Purchase Order work?"
  },
  {
    answer: (
      <>
        Yes! LitCharts subscription plans include access to tons of exclusive
        features, such as our AI Teaching Tools and our premium analysis
        content. Below are samples of the downloadable versions of a few of our
        thousands of guides and classroom-ready resources.
        <br />
        <ul>
          <li>
            <a
              href="/mrs-dalloway-sample.pdf"
              target="_blank"
              rel="noopener noreferrer"
              title="LitCharts Free Sample Literature Guide PDF"
            >
              Literature Guide
            </a>
          </li>
          <li>
            <a
              href="/mrs-dalloway.zip"
              target="_blank"
              rel="noopener noreferrer"
              title="LitCharts Free Sample Teacher Edition"
            >
              Teacher Edition
            </a>
          </li>
          <li>
            <a
              href="/LitCharts-Anapest-Sample.pdf"
              target="_blank"
              rel="noopener noreferrer"
              title="LitCharts Free Sample Literary Term PDF"
            >
              Literary Term
            </a>
          </li>
          <li>
            <a
              href="/Shakescleare-Hamlet-Sample.pdf"
              target="_blank"
              rel="noopener noreferrer"
              title="Hamlet Shakescleare Free Sample PDF"
            >
              Shakescleare Translation
            </a>
            <span> (excerpt)</span>
          </li>
        </ul>
      </>
    ),
    question: "Can I see some free samples?"
  }
];

const FaqSection = () => (
  <div className="tw-z-10 tw-w-full tw-mt-10 tw-flex tw-justify-center">
    <div className="tw-w-full tw-max-w-[932px]">
      <h2 className="title-6 tw-m-0 tw-py-[10px] tw-px-[15px]">FAQs</h2>
      <div className="tw-flex tw-flex-col">
        {faqData.map((faq) => (
          <div
            className="groups-info__expandable-row--wrapper"
            key={faq.question}
          >
            <GroupsInfoExpandableFaqRow
              question={faq.question}
              answer={faq.answer}
            />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default FaqSection;
